import { AxiosResponse } from 'axios';
import { useAlert } from 'core/contexts';
import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { commonShowAlert } from 'lib';
import { useMutation, UseMutationResult } from 'react-query';

interface CancelJobProps {
    jobId: string;
    token: string;
}

export const cancelJob = (props: CancelJobProps): Promise<AxiosResponse> => {
    const headers = getDefaultHeaders(props.token);
    const url = `/jobs/${props.jobId}`;

    return axiosInstance().delete(url, withHeaders(headers));
};

export const useCancelJob = (): UseMutationResult<
    AxiosResponse<any, any>,
    any,
    CancelJobProps,
    unknown
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(cancelJob, {
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to cancel job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
